/**
 * 메일 서버 설정
 *
 * @since 2018-10-05
 * @author jupil.Go <devp018>
 */

import {i18n} from '~/plugins/i18n'
import {CmApiPrefix as apiPrefix} from '~/utils/restApi'

const initMailSvrPageData = () => {
  return {
    device_list: [],
    // admin_login_uname: '', // (string, optional): 관리자 로그인 이름 ,
    // admin_name: '', // (string, optional): 관리자 이름 ,
    // cfg_admin_id: 0, // (integer, optional): 설정 관리자 아이디 ,
    // cfg_dt: '', // (string, optional): 설정 일시 ,
    // device_id: [], // (Array[integer]): 대상장비
    mail_server_cm_sync_yn: 0, // '메일 서버 통합 설정 동기화 여부 0: false, 1: true'
    mail_server_cm_desc: '', // (string, optional): 메일 서버 통합 설정 설명 ,
    mail_server_cm_id: 0, // (integer, optional): 메일 서버 통합 설정 아이디 ,
    mail_server_cm_log_set: [], // (string, optional): 메일 서버 통합 설정 로그 항목 설정 ,
    mail_server_cm_log_opt_set: [],
    mail_server_cm_log_sync_set: [], // (string, optional): 메일 서버 통합 설정 로그 동기화 여부 설정 ,
    mail_server_cm_sender_email: '', // (string, optional): 메일 서버 통합 설정 발신자 이메일 ,
    mail_server_cm_sender_sync_yn: 0, // (integer, optional): 메일 서버 통합 설정 발신자 동기화 여부 0 false 1 true ,
    mail_server_cm_server_addr_val: '', // (string, optional): 메일 서버 통합 설정 서버 주소 값 ,
    mail_server_cm_server_auth_login_name: '', // (string, optional): 메일 서버 통합 설정 인증 로그인 이름 ,
    mail_server_cm_server_auth_login_pw: '', // (string, optional): 메일 서버 통합 설정 인증 로그인 암호 ,
    mail_server_cm_server_auth_use_yn: 0, // (integer, optional): 메일 서버 통합 설정 인증 사용 여부 0 false 1 true ,
    mail_server_cm_server_enc_type: 0, // (integer, optional): 메일 서버 통합 설정 보안 연결 유형 ,
    mail_server_cm_server_port: 0, // (integer, optional): 메일 서버 통합 설정 서버 포트 ,
    mail_server_cm_server_sync_yn: 0, // (integer, optional): 메일 서버 통합 설정 서버 정보 동기화 여부 0 false 1 true ,
    mail_server_cm_server_use_yn: 0, // (integer, optional): 메일 서버 통합 설정 서버 설정 사용 여부 0 false 1 true ,
    mail_server_cm_uname: '', // (string, optional): 메일 서버 통합 설정 이름
    mail_server_cm_device_model_type: 20
  }
}

function makeSyncSetData (param) {
  try {
    const data = _.cloneDeep(param)
    const res = {}
    if (_.size(data) > 0) {
      data.forEach((o, index) => {
        res[`sync_set${index + 1}`] = o
      })
    } else {
      return void 0
    }
    return res
  } catch (e) {
    return void 0
  }
}

export const state = () => ({
  url: `${apiPrefix}/mail-server-cm`,
  mailSvrDataList: [],
  mailSvrPageData: initMailSvrPageData(),
  logInfoList: [],
  defaultList: [],
  defaultOptionList: [],
  syncData: {}
})

export const mutations = {
  initStore (state) {
    state.mailSvrDataList = []
    state.mailSvrPageData = initMailSvrPageData()
    state.logInfoList = []
    state.defaultList = []
    state.defaultOptionList = []
    state.syncData = {}
  },
  clearMailSvrDialog: (state) => {
    state.mailSvrPageData = initMailSvrPageData()
  },
  clearMailSvrDeviceList (state) {
    state.mailSvrPageData.device_list = []
  },
  clearMailServerAuthLoginName (state) {
    state.mailSvrPageData.mail_server_cm_server_auth_login_name = ''
  },
  // 리스트 조회
  setMailSvrData (state, item) {
    // state.logInfoList = []
    state.mailSvrDataList = _.cloneDeep(item)
  },
  setCmId (state, id) {
    state.mailSvrPageData.mail_server_cm_id = id
  },
  setSyncData (state, data) {
    state.syncData = _.omit(data, ['name', 'itemIndex', '_itemKey'])
    state.mailSvrPageData.mail_server_cm_log_sync_set = _.cloneDeep(_.values(state.syncData))
  },
  initLogData (state) {
    // 동기화 value 모두 0으로 설정
    state.mailSvrPageData.mail_server_cm_log_sync_set.fill(0)
    state.syncData = makeSyncSetData(state.mailSvrPageData.mail_server_cm_log_sync_set)
  },
  addMailSvr: (state, item) => {
    state.mailSvrDataList.push(item)
  },
  // edtMailSvr: (state, item) => {
  //   state.mailSvrDataList.splice(state.selectedItem.itemIndex, 1, item)
  // },
  // delMailSvr: (state, itemIndexList) => {
  //   itemIndexList = _.sortBy(itemIndexList, 'itemIndex').reverse()
  //   for (const itemIndex of itemIndexList) {
  //     state.mailSvrDataList.splice(itemIndex, 1)
  //   }
  // },
  delMailSvr: (state, itemList) => {
    for (const itemKey of itemList.mail_server_cm_id_list) {
      const idx = _.findIndex(state.mailSvrDataList, {mail_server_cm_id: itemKey})
      if (idx >= 0) {
        state.mailSvrDataList.splice(idx, 1)
      }
    }
  },
  setMailSvrDialog (state, data) {
    const mailSvrPageData = _.cloneDeep(data)

    state.mailSvrPageData.mail_server_cm_id = mailSvrPageData.mail_server_cm_id
    state.mailSvrPageData.mail_server_cm_uname = mailSvrPageData.mail_server_cm_uname
    state.mailSvrPageData.mail_server_cm_desc = mailSvrPageData.mail_server_cm_desc
    state.mailSvrPageData.mail_server_cm_sync_yn = mailSvrPageData.mail_server_cm_sync_yn
    state.mailSvrPageData.mail_server_cm_sender_sync_yn = mailSvrPageData.mail_server_cm_sender_sync_yn
    state.mailSvrPageData.mail_server_cm_sender_email = mailSvrPageData.mail_server_cm_sender_email
    state.mailSvrPageData.mail_server_cm_server_sync_yn = mailSvrPageData.mail_server_cm_server_sync_yn
    state.mailSvrPageData.mail_server_cm_server_use_yn = mailSvrPageData.mail_server_cm_server_use_yn
    state.mailSvrPageData.mail_server_cm_server_addr_val = mailSvrPageData.mail_server_cm_server_addr_val
    state.mailSvrPageData.mail_server_cm_server_port = mailSvrPageData.mail_server_cm_server_port
    state.mailSvrPageData.mail_server_cm_server_enc_type = mailSvrPageData.mail_server_cm_server_enc_type
    state.mailSvrPageData.mail_server_cm_server_auth_use_yn = mailSvrPageData.mail_server_cm_server_auth_use_yn
    state.mailSvrPageData.mail_server_cm_server_auth_login_name = mailSvrPageData.mail_server_cm_server_auth_login_name

    state.mailSvrPageData.mail_server_cm_device_model_type = mailSvrPageData.mail_server_cm_device_model_type
    state.mailSvrPageData.device_list = mailSvrPageData.device_list

    state.mailSvrPageData.mail_server_cm_log_sync_set = JSON.parse(mailSvrPageData.mail_server_cm_log_sync_set)
    state.syncData = _.cloneDeep(makeSyncSetData(state.mailSvrPageData.mail_server_cm_log_sync_set))

    state.mailSvrPageData.mail_server_cm_log_set = JSON.parse(mailSvrPageData.mail_server_cm_log_set)
    state.defaultList = state.mailSvrPageData.mail_server_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)

    state.mailSvrPageData.mail_server_cm_log_opt_set = JSON.parse(data.mail_server_cm_log_opt_set)
    state.defaultOptionList = state.mailSvrPageData.mail_server_cm_log_opt_set
  },
  setMailSvrOptionList (state, data) {
    state.mailSvrPageData.mail_server_cm_log_opt_set = _.cloneDeep(data)
    state.defaultOptionList = _.cloneDeep(state.mailSvrPageData.mail_server_cm_log_opt_set)
  },
  setMailSvrDeviceList (state, data) {
    if (_.get(data, ['length'], 0) > 0) {
      state.mailSvrPageData.device_list = _.cloneDeep(data)
    }
  },
  setMailSvrLogEntitiesSettings (state, payload) {
    state.mailSvrPageData.mail_server_cm_log_set = payload

    state.defaultList = state.mailSvrPageData.mail_server_cm_log_set
    state.logInfoList = _.cloneDeep(state.defaultList)
  }
}

export const actions = {
  // 리스트 조회
  async getMailSvrData ({commit, state}, { loading = true } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const ALL_MAIL_SVR_SETTINGS = 0
      res = await this.$axios.$get(`${state.url}/${ALL_MAIL_SVR_SETTINGS}`, { loading })
      if (res.code === 'ok') {
        commit('setMailSvrData', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addBeanMailSvr ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(state.url, null, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getMailSvr ({commit, state}, { id }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}/${id}`, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setMailSvrDialog', res.result[0])
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addMailSvr ({commit, state}, { password }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_id_list: _.map(state.mailSvrPageData.device_list, 'device_id'),
        // device_list_name: '',
        mail_server_cm_desc: state.mailSvrPageData.mail_server_cm_desc,
        mail_server_cm_id: state.mailSvrPageData.mail_server_cm_id,
        mail_server_cm_log_set: JSON.stringify(state.logInfoList),
        mail_server_cm_log_opt_set: JSON.stringify(state.mailSvrPageData.mail_server_cm_log_opt_set),
        mail_server_cm_log_sync_set: JSON.stringify(state.mailSvrPageData.mail_server_cm_log_sync_set),
        mail_server_cm_sender_email: state.mailSvrPageData.mail_server_cm_sender_email,
        mail_server_cm_server_addr_val: state.mailSvrPageData.mail_server_cm_server_addr_val,
        mail_server_cm_server_auth_login_name: state.mailSvrPageData.mail_server_cm_server_auth_login_name,
        mail_server_cm_server_auth_login_pw: _.get(password, ['length'], 0) > 0 ? password : null,
        mail_server_cm_server_auth_use_yn: state.mailSvrPageData.mail_server_cm_server_auth_use_yn,
        mail_server_cm_server_enc_type: state.mailSvrPageData.mail_server_cm_server_enc_type,
        mail_server_cm_server_port: state.mailSvrPageData.mail_server_cm_server_port,
        mail_server_cm_server_use_yn: state.mailSvrPageData.mail_server_cm_server_use_yn,
        mail_server_cm_sync_yn: state.mailSvrPageData.mail_server_cm_sync_yn,
        mail_server_cm_uname: state.mailSvrPageData.mail_server_cm_uname,
        mail_server_cm_device_model_type: state.mailSvrPageData.mail_server_cm_device_model_type
      }
      res = await this.$axios.$put(state.url, params, {loading: false, successAlert: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async edtMailSvr ({commit, state}, {password}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_id_list: _.map(state.mailSvrPageData.device_list, 'device_id'),
        // device_list_name: '',
        mail_server_cm_desc: state.mailSvrPageData.mail_server_cm_desc,
        mail_server_cm_id: state.mailSvrPageData.mail_server_cm_id,
        mail_server_cm_log_set: JSON.stringify(state.logInfoList),
        mail_server_cm_log_opt_set: JSON.stringify(state.mailSvrPageData.mail_server_cm_log_opt_set),
        mail_server_cm_log_sync_set: JSON.stringify(state.mailSvrPageData.mail_server_cm_log_sync_set),
        mail_server_cm_sender_email: state.mailSvrPageData.mail_server_cm_sender_email,
        mail_server_cm_server_addr_val: state.mailSvrPageData.mail_server_cm_server_addr_val,
        mail_server_cm_server_auth_login_name: state.mailSvrPageData.mail_server_cm_server_auth_login_name,
        mail_server_cm_server_auth_login_pw: _.get(password, ['length'], 0) > 0 ? password : null,
        mail_server_cm_server_auth_use_yn: state.mailSvrPageData.mail_server_cm_server_auth_use_yn,
        mail_server_cm_server_enc_type: state.mailSvrPageData.mail_server_cm_server_enc_type,
        mail_server_cm_server_port: state.mailSvrPageData.mail_server_cm_server_port,
        mail_server_cm_server_use_yn: state.mailSvrPageData.mail_server_cm_server_use_yn,
        mail_server_cm_sync_yn: state.mailSvrPageData.mail_server_cm_sync_yn,
        mail_server_cm_uname: state.mailSvrPageData.mail_server_cm_uname,
        mail_server_cm_device_model_type: state.mailSvrPageData.mail_server_cm_device_model_type
      }
      res = await this.$axios.$put(state.url, params)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delMailSvr ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const isShow = _.has(param, 'isShow') ? param.isShow : true
      const isAlert = _.has(param, 'isAlert') ? param.isAlert : true

      res = await this.$axios.$put(`${state.url}/multi`, param.idList, {
        loading: isShow,
        successAlert: isAlert,
        alertMsg: i18n.t('msg.removeApply')
      })

      if (res.code === 'ok') {
        commit('delMailSvr', param.idList)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async initMailSvrLogEntitiesSettings ({ commit, state }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.url}/log-set/${state.mailSvrPageData.mail_server_cm_device_model_type}/init`, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'ok') {
        commit('setMailSvrLogEntitiesSettings', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async processMailSvrSync ({commit, state}, param) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.url}/multi`, param, {loading: false, isNotAlert: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async finalCommand ({state}, type) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const axiosConfig = (type === 'apply') ? {applyMsg: true} : {cancelMsg: true}
      res = await this.$axios.$put(`${state.url}/${type}`, void 0, axiosConfig)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}

export const strict = false
